import { apiSlice } from '../../app/services/apiSlice';

const BASE_URL = '/vendor/florist/subscription';

export const billingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCurrentSubscription: builder.query({
      query: () => ({
        url: `${BASE_URL}/getSubscription`,
        method: 'POST',
        body: '',
      }),
      providesTags: ['SubscriptionDetail'],
      transformResponse: (response) => response?.objectData,
    }),
    fetchCustomerPortalLink: builder.query({
      query: () => ({
        url: `${BASE_URL}/getCustomerPortalLink`,
        method: 'POST',
        body: '',
      }),
      // providesTags: ['SubscriptionDetail'],
      transformResponse: (response) => response?.objectData,
    }),
    upgradeSubscription: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/upgradeSubscription`,
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['preLiveChecks'],
      transformResponse: (response) => response?.objectData,
    }),
    createSubscription: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/createSubscription`,
        method: 'POST',
        body: body,
      }),
      // invalidatesTags: ['SubscriptionDetail', 'preLiveChecks'],
      transformResponse: (response) => ({
        data: response?.objectData,
        statusCode: response?.code,
      }),
    }),
    applyCouponCode: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/applyCoupon`,
        method: 'POST',
        body: body,
      }),
      transformResponse: (response) => response?.objectData,
    }),
    cancelSubscription: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/cancelSubscription`,
        method: 'DELETE',
        body: body,
      }),
      invalidatesTags: ['preLiveChecks', 'SubscriptionDetail'],
      transformResponse: (response) => response?.objectData,
    }),
    fetchUpcomingInvoiceForSubscription: builder.query({
      query: () => ({
        url: `${BASE_URL}/getUpcomingInvoiceForSubscription`,
      }),
      providesTags: ['SubscriptionDetail'],
      transformResponse: (response) => response?.objectData,
    }),
    fetchPaymentMethods: builder.query({
      query: () => ({
        url: `${BASE_URL}/getPaymentMethods`,
      }),
      providesTags: ['SubscriptionDetail'],
      transformResponse: (response) => response?.objectData,
    }),
    fetchInvoicesForSubscription: builder.query({
      query: () => ({
        url: `${BASE_URL}/getInvoicesForSubscription`,
      }),
      providesTags: ['SubscriptionDetail'],
      transformResponse: (response) => response?.objectData,
    }),
    attachPaymentMethod: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/attachPaymentMethod`,
        method: 'POST',
        body: body,
      }),
      transformResponse: (response) => response?.objectData,
    }),
    makeDefaultPaymentMethod: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/makeDefaultPaymentMethod`,
        method: 'POST',
        body: body,
      }),
      transformResponse: (response) => response?.objectData,
    }),
    deletePaymentMethod: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/detachPaymentMethod`,
        method: 'DELETE',
        body: body,
      }),
      transformResponse: (response) => response?.objectData,
    }),
    updateSelectionAndPaymentStatus: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/updateSelectionAndPaymentStatus`,
        method: 'POST',
        body: body,
      }),
      invalidatesTags: ['preLiveChecks', 'SubscriptionDetail'],
      transformResponse: (response) => response?.objectData,
    }),
    calculateSubscriptionUsage: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/calculateUsage`,
        method: 'POST',
        body: body,
      }),
      transformResponse: (response) => response?.objectData,
    }),
  }),
});
export const {
  useFetchCurrentSubscriptionQuery,
  useFetchCustomerPortalLinkQuery,
  useCreateSubscriptionMutation,
  useApplyCouponCodeMutation,
  useUpgradeSubscriptionMutation,
  useCancelSubscriptionMutation,
  useFetchInvoicesForSubscriptionQuery,
  useFetchPaymentMethodsQuery,
  useFetchUpcomingInvoiceForSubscriptionQuery,
  useAttachPaymentMethodMutation,
  useMakeDefaultPaymentMethodMutation,
  useDeletePaymentMethodMutation,
  useUpdateSelectionAndPaymentStatusMutation,
  useCalculateSubscriptionUsageMutation,
} = billingApiSlice;
